import { Grid } from '@design-system';

import { InsightListStoryblok } from '../types/generated-storyblok';
import { ArticleInsight } from './Journals/ArticleInsight';

interface ContentBlockInsightsProps {
  blok: InsightListStoryblok;
}

export const ContentBlockInsights = ({ blok }: ContentBlockInsightsProps) => (
  <Grid className="gap-y-6" columns={4}>
    {blok.insights.map((insight) => {
      return (
        <div key={insight._uid} className="relative">
          <ArticleInsight blok={insight} variant="card" />
        </div>
      );
    })}
  </Grid>
);
